import { envConfig } from "../env";
import GADConfig from "../google-automated-discount";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const ngEuMerchant = "738826960";

const netherlands: MarketConfiguration = {
  code: MarketEnum.nl,
  label: "Netherlands",
  descriptiveLabel: "Dutch",
  testfreaksClientId: envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID,
  searchEngineUrl: envConfig.NEXT_PUBLIC_SEARCH_ENGINE_URL_NL,
  contentfulLocale: ContentfulEnum.nl,
  contentfulCountry: "Netherlands",
  locale: LocaleEnum.nl,
  serviceLocale: ServiceLocaleEnum.nl,
  language: {
    code: "nl",
    label: "Dutch",
    flag: "nl",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/nl",
  termsSlug: "algemene-voorwaarden-online-aankopen",
  loop54Market: MarketEnum.nl,
  adyenMarket: MarketEnum.nl,
  elevateMarket: ElevateMarketEnum.nl,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-nl",
  searchPathName: "zoeken",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  googleAutomatedDiscounts: {
    allowedInTest: {
      allowedMerchants: new Set([ngEuMerchant, GADConfig.testMerchantId]),
      allowedPublicKeys: [
        GADConfig.testPublicKey,
        GADConfig.googleProductionPublicKey,
      ],
    },
    allowedInProd: {
      allowedMerchants: new Set([ngEuMerchant]),
      allowedPublicKeys: [GADConfig.googleProductionPublicKey],
    },
  },
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default netherlands;
